/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityByComponentRequest extends models.AppSecopsFilter {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityByComponentRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityByComponentRequest>): AppSecopsVulnerabilityByComponentRequest {
        let obj = Object.assign(new AppSecopsVulnerabilityByComponentRequest(), model);
        AppSecopsVulnerabilityByComponentRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityByComponentRequest>): AppSecopsVulnerabilityByComponentRequest {
        if (!model) return null;
        return AppSecopsVulnerabilityByComponentRequest.newInstance(<AppSecopsVulnerabilityByComponentRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityByComponentRequest) {
        if (!obj) return;

        models.AppSecopsVulnerabilityByComponentRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityByComponentRequest): boolean {
        if (models.AppSecopsFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityByComponentRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Component property category
     */
    category: Array<models.AppSecopsComponentGroupingCategory>;

}
